import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import makeCustomButtonActionFunction from 'notebook/structured-tables/action-functions/makeCustomButtonActionFunction';
import unsupportedOverflowMenuItem from 'notebook/structured-tables/action-functions/unsupportedOverflowMenuItem';
import {ActionFunctionParameters} from 'notebook/structured-tables/StructuredTableConstants';
import CreateProcessButton from 'processes/tables/create-process-button/CreateProcessButton';

function renderToolbarButton<TTableMetadata, TRowMetadata>({
  structuredTable,
  structuredTableAdapter,
  computedTable,
}: ActionFunctionParameters<TTableMetadata, TRowMetadata>): JSX.Element {
  return (
    <CreateProcessButton
      structuredTable={structuredTable}
      structuredTableAdapter={structuredTableAdapter}
      computedTable={computedTable}
    />
  );
}

export const createProcessActionFunction = makeCustomButtonActionFunction({
  renderToolbarButton,
  renderOverflowMenuItem: unsupportedOverflowMenuItem,
  getHidden: () => !BenchlingConfig.WORKFLOWS_ENABLE,
});
